<template>
  <div id="ExportManage" class="well" style="padding: 0 1em">
    <b-button variant="success" v-on:click="dataMode = 1"
      >上傳教育部審核資料(D185在最後)</b-button
    >
    <b-button variant="success" v-on:click="dataMode = 2"
      >上傳主計系統(不含D185)</b-button
    >
    <b-button variant="success" v-on:click="dataMode = 3"
      >上傳主計系統1(D185)</b-button
    >

    <div>目前共 {{ total }}筆</div>
    <b-tabs content-class="mt-3" justified>

      <b-tab :active="dataMode == 1" :disabled="dataMode != 1">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 1em">申請學年度：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>

                <th style="min-width: 1em">學期：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="1"
                    v-model="queryInfo.ETime"
                    placeholder="如1"
                  />
                </th>

                <th style="min-width: 30em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query1()"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/EconomicDisadvantage/GetEduReviewCSV/'
                        .concat(queryInfo.STime)
                        .concat(',')
                        .concat(queryInfo.ETime)
                        .concat(',')
                        .concat(queryInfo.dataMode)
                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.CSV_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <table
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 5em">流水號</th>
                <th style="min-width: 5em">學生身分證字號</th>

                <th style="min-width: 5em">學生姓名</th>

                <th style="min-width: 5em">學號</th>
                <th style="min-width: 5em">學制</th>
                <th style="min-width: 1em">部別</th>
                <th style="min-width: 2em">年級</th>
                <th style="min-width: 2em">專班編號</th>
                <th style="min-width: 2em">學生關係人1身分字號</th>
                <th style="min-width: 2em">學生關係人1身分別</th>
                <th style="min-width: 2em">學生關係人2身分字號</th>
                <th style="min-width: 2em">學生關係人2身分別</th>

                <th style="min-width: 2em">學生關係人3身分字號</th>
                <th style="min-width: 2em">學生關係人3身分別</th>
                <th style="min-width: 2em">關係人總數</th>
              </tr>
            </thead>
            <tbody class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in docRecordList"
                :key="item.id"
                :index="item.id"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: right">
                  {{ item.id }}
                </td>
                <td style="text-align: left">{{ item.idNo }}</td>
                <td style="text-align: left">{{ item.name }}</td>
                <td style="text-align: left">{{ item.sid }}</td>
                <td style="text-align: left">5</td>
                <td style="text-align: left">2</td>
                <td style="text-align: left">{{ item.gd }}</td>
                <td style="text-align: left">{{ item.specialClassNumber }}</td>
                <td style="text-align: left">{{ item.relatedId1 }}</td>
                <td style="text-align: left">{{ item.relatedStudent1 }}</td>
                <td style="text-align: left">{{ item.relatedId2 }}</td>
                <td style="text-align: left">{{ item.relatedStudent2 }}</td>
                <td style="text-align: left">{{ item.relatedId3 }}</td>
                <td style="text-align: left">{{ item.relatedStudent3 }}</td>
                <td style="text-align: left">{{ item.relatedTotal }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>

      <b-tab :active="dataMode == 2" :disabled="dataMode != 2">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 2em">申請學年度：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>

                <th style="min-width: 2em">學期：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="1"
                    v-model="queryInfo.ETime"
                    placeholder="如1"
                  />
                </th>
                <th style="min-width: 2em">不含系所代碼：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[d][^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="4"
                    v-model="queryInfo.Text1"
                    placeholder="如D185"
                  />
                </th>

                <th style="min-width: 2em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query(false)"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/EconomicDisadvantage/GetSportsCSV/'
                        .concat(queryInfo.STime)
                        .concat(',')
                        .concat(queryInfo.ETime)
                        .concat(',')
                        .concat(queryInfo.dataMode)
                        .concat(',')
                        .concat(queryInfo.Text1)
                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.CSV_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >

          <table
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 5em">身分證字號</th>
                <th style="min-width: 5em">姓名</th>

                <th style="min-width: 10em">帳號</th>

                <th style="min-width: 7em">銀行代碼</th>
                <th style="min-width: 5em">職別(稱)</th>
                <th style="min-width: 15em">戶籍地址</th>
                <th style="min-width: 2em">身份別代碼</th>
                <th style="min-width: 2em">單位(ex:時,月,次...)</th>
                <th style="min-width: 2em">數量</th>
                <th style="min-width: 2em">單價</th>
                <th style="min-width: 2em">機關負擔勞保費</th>
                <th style="min-width: 2em">機關負擔補充保費</th>

                <th style="min-width: 2em">機關負擔勞退金</th>
                <th style="min-width: 2em">機關負擔離職金</th>
                <th style="min-width: 2em">個人自付勞保費</th>
                <th style="min-width: 2em">個人自付補充保費</th>
                <th style="min-width: 2em">個人自付勞退金</th>
                <th style="min-width: 2em">個人自付離職金</th>
                <th style="min-width: 2em">代扣所得</th>
                <th style="min-width: 2em">其他代扣</th>
                <th style="min-width: 2em">免稅給付</th>
                <th style="min-width: 2em">說明</th>
              </tr>
            </thead>
            <tbody class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in docRecordList"
                :key="item.idno"
                :index="item.idno"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: right">
                  {{ item.idno }}
                </td>
                <td style="text-align: left">{{ item.name }}</td>
                <td style="text-align: left">{{ item.postno }}</td>
                <td style="text-align: left">{{ item.postsubID }}</td>
                <td style="text-align: left"></td>
                <td style="text-align: left">{{ item.hmadd1 }}</td>
                <td style="text-align: left">9</td>
                <td style="text-align: left">次</td>
                <td style="text-align: left">1</td>
                <td style="text-align: left">20000</td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left">
                  {{
                    queryInfo.STime +
                    "-" +
                    queryInfo.ETime +
                    "產學攜手經濟不利學生助學金補助"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>
      <b-tab :active="dataMode == 3" :disabled="dataMode != 3">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 2em">申請學年度：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>

                <th style="min-width: 2em">學期：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="1"
                    v-model="queryInfo.ETime"
                    placeholder="如1"
                  />
                </th>
                <th style="min-width: 2em">含系所代碼：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[d][^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="4"
                    v-model="queryInfo.Text1"
                    placeholder="如D185"
                  />
                </th>

                <th style="min-width: 20em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query(false)"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/EconomicDisadvantage/GetSportsCSV2/'
                        .concat(queryInfo.STime)
                        .concat(',')
                        .concat(queryInfo.ETime)
                        .concat(',')
                        .concat(queryInfo.dataMode)
                        .concat(',')
                        .concat(queryInfo.Text1)
                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.CSV_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "

        >
          <table
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 5em">身分證字號</th>
                <th style="min-width: 5em">姓名</th>

                <th style="min-width: 10em">帳號</th>

                <th style="min-width: 7em">銀行代碼</th>
                <th style="min-width: 5em">職別(稱)</th>
                <th style="min-width: 15em">戶籍地址</th>
                <th style="min-width: 2em">身份別代碼</th>
                <th style="min-width: 2em">單位(ex:時,月,次...)</th>
                <th style="min-width: 2em">數量</th>
                <th style="min-width: 2em">單價</th>
                <th style="min-width: 2em">機關負擔勞保費</th>
                <th style="min-width: 2em">機關負擔補充保費</th>

                <th style="min-width: 2em">機關負擔勞退金</th>
                <th style="min-width: 2em">機關負擔離職金</th>
                <th style="min-width: 2em">個人自付勞保費</th>
                <th style="min-width: 2em">個人自付補充保費</th>
                <th style="min-width: 2em">個人自付勞退金</th>
                <th style="min-width: 2em">個人自付離職金</th>
                <th style="min-width: 2em">代扣所得</th>
                <th style="min-width: 2em">其他代扣</th>
                <th style="min-width: 2em">免稅給付</th>
                <th style="min-width: 2em">說明</th>
              </tr>
            </thead>
            <tbody class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in docRecordList"
                :key="item.idno"
                :index="item.idno"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: right">
                  {{ item.idno }}
                </td>
                <td style="text-align: left">{{ item.name }}</td>
                <td style="text-align: left">{{ item.postno }}</td>
                <td style="text-align: left">{{ item.postsubID }}</td>
                <td style="text-align: left"></td>
                <td style="text-align: left">{{ item.hmadd1 }}</td>
                <td style="text-align: left">9</td>
                <td style="text-align: left">次</td>
                <td style="text-align: left">1</td>
                <td style="text-align: left">20000</td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left">
                  {{
                    queryInfo.STime +
                    "-" +
                    queryInfo.ETime +
                    "產學攜手經濟不利學生助學金補助"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>

    </b-tabs>
  </div>
</template>

<script  id="modal-template">
import * as tools from "../tool";
export default {
  name: "ExportManage",
  data() {
    return {
      total: 0,
      dataMode: 1,
      currentPage: 1,
      selectedRowIndex: 0,
      editId: 0,
      pageSize: 10,
      queryInfo: {
        STime: null,
        ETime: null,
        dataMode: 1,
        Text1: null,
        Flag:false,
      },
      docRecordList: null,
    };
  },

  computed: {
    sysId() {
      return this.$store.getters.getSysId;
    },
    setting() {
      return this.$store.getters.getSetting;
    },

    filteredDocs: function () {
      let data = [];
      if (this.docRecordList != null) {
        data = this.docRecordList.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  filters: {},
  methods: {
    checkSaveData() {
      let msg = "";
      if (this.isEmpty(this.queryInfo.STime)) msg = "請輸入申請學年度";
      else if (this.isEmpty(this.queryInfo.ETime)) msg = "請輸入學期";
      else if (this.isEmpty(this.queryInfo.Text1) && this.dataMode != 1) msg = "請輸入系所代碼";

      return msg;
    },
    query(Flag) {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.docRecordList = null;
        vm.total = 0;
        vm.queryInfo.dataMode = vm.dataMode;
        vm.queryInfo.Flag = Flag;

        this.$http
          .put("./WebApi/EconomicDisadvantage/GetSportsList3", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data;
              vm.total = vm.docRecordList.length;
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
    isEmpty(data) {
      return data != "" && data != null && data != undefined && data.length > 0
        ? false
        : true;
    },
    query1() {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.docRecordList = null;
        vm.total = 0;
        vm.queryInfo.dataMode = vm.dataMode;

        this.$http
          .put("./WebApi/EconomicDisadvantage/GetEduReview", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data;
              vm.total = vm.docRecordList.length;
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
  },
  created() {
    console.log("======created ReportManageView =====");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
.span_text {
  display: block;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
